function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  transform: "translate(-164.000000, -303.000000)",
  fill: "#FFB400",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "button-jobs",
  transform: "translate(103.000000, 262.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-jobs",
  transform: "translate(61.000000, 41.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "32 36 46 36 46 41 32 41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.2803802,40.4630175 L50.4257812,40.4630175 L50.4257812,42.7577661 C50.4257812,44.0258536 49.4034118,45.0525146 48.140625,45.0525146 L29.859375,45.0525146 C28.5965882,45.0525146 27.5742188,44.0258536 27.5742188,42.7577661 L27.5742188,40.4630175 L14.7196198,40.4630175 C11.7649841,40.4630175 9.1519318,38.5716428 8.21644596,35.7569902 L0,11 L0,61.1157544 C0,64.9116509 3.07543945,68 6.85546875,68 L71.1445312,68 C74.9245605,68 78,64.9116509 78,61.1157544 L78,11.0017928 L69.782959,35.7569902 C68.8480682,38.5716428 66.2350159,40.4630175 63.2803802,40.4630175 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.7527894,0 L29.2466082,0 C25.4200697,0 22.3067903,3.028125 22.3067903,6.75 L22.3067903,9 L3,9 L11.7247727,34.4619141 C12.0410406,35.3824218 12.9241805,36 13.9205746,36 L26.9333356,36 L26.9333356,33.75 C26.9333356,32.5066407 27.9682842,31.5 29.2466082,31.5 L47.7527894,31.5 C49.0311134,31.5 50.066062,32.5066407 50.066062,33.75 L50.066062,36 L63.078823,36 C64.0752171,36 64.958357,35.3824218 65.2746249,34.4619141 L74,9 L54.6926073,9 L54.6926073,6.75 C54.6926073,3.028125 51.5793279,0 47.7527894,0 Z M26.9333356,9 L26.9333356,6.75 C26.9333356,5.5083984 27.9700913,4.5 29.2466082,4.5 L47.7527894,4.5 C49.0293063,4.5 50.066062,5.5083984 50.066062,6.75 L50.066062,9 L26.9333356,9 Z",
  id: "Shape"
})))));

function SvgIconJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "68px",
    viewBox: "0 0 78 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-jobs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJobs);
export default __webpack_public_path__ + "static/media/icon-jobs.80198d65.svg";
export { ForwardRef as ReactComponent };